import { render, staticRenderFns } from "./GiftBackfill.vue?vue&type=template&id=21c2e650&scoped=true"
import script from "./GiftBackfill.vue?vue&type=script&lang=js"
export * from "./GiftBackfill.vue?vue&type=script&lang=js"
import style0 from "./GiftBackfill.vue?vue&type=style&index=0&id=21c2e650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c2e650",
  null
  
)

export default component.exports